import type {
  NavigateOptions,
  UpdateChatInputOptions,
} from '../api/registerPleriApi';

export class PleriClient {
  static updateChatInput(options: UpdateChatInputOptions) {
    if (typeof window !== 'undefined' && window.pleriChat?.updateChatInput) {
      window.pleriChat.updateChatInput(options);
    } else {
      console.error('Pleri chat API is not available on window');
    }
  }

  static navigate(options: NavigateOptions) {
    if (typeof window !== 'undefined' && window.pleriChat?.navigate) {
      window.pleriChat.navigate(options);
    } else {
      console.error('Pleri chat navigation API is not available on window');
    }
  }
}
